/* eslint-disable indent */
import React from 'react';

// 只有部分飯店的部分語言有愛旅行回饋計劃
const TW_REWARD_LINK = {
	'jiaoxi': 'https://member.silkshotelgroup.com/Campaign/Index/JSJX',
	'ximending': 'https://member.silkshotelgroup.com/Campaign/Index/JSXMD',
	'sanchong': 'https://member.silkshotelgroup.com/Campaign/Index/JSSC',
	'NTU': 'https://member.silkshotelgroup.com/Campaign/Index/JSNTU',
	'zhongshan': 'https://member.silkshotelgroup.com/Campaign/Index/JSZS'
};

const EN_REWARD_LINK = {
	'jiaoxi': 'https://member.silkshotelgroup.com/en/Campaign/Index/JSJX',
	'ximending': 'https://member.silkshotelgroup.com/en/Campaign/Index/JSXMD',
	'sanchong': 'https://member.silkshotelgroup.com/en/Campaign/Index/JSSC',
	'NTU': 'https://member.silkshotelgroup.com/en/Campaign/Index/JSNTU',
	'zhongshan': 'https://member.silkshotelgroup.com/en/Campaign/Index/JSZS'
};

const NavExtraItem = ({ className, hotel, lan }) => {
	if (
		(hotel === 'hualien' && lan === 'zh-TW') ||
		(hotel === 'kaohsiung' && lan === 'zh-TW') ||
		(hotel === 'kaohsiungStation' && lan === 'zh-TW')
	) {
		return (
			<a
				className={className}
				href="https://member.silkshotelgroup.com/Campaign/Index/JS"
				target="_blank"
				rel="noopener noreferrer"
			>
				集點享樂回饋計劃
			</a>
		);
	}

	if (lan === 'zh-TW' && hotel in TW_REWARD_LINK) {
		const hotelLink = TW_REWARD_LINK[hotel];

		return (
			<a className={className} href={hotelLink} target="_blank" rel="noopener noreferrer">
				愛旅行回饋計劃
			</a>
		);
	}

	if (lan === 'en' && hotel in EN_REWARD_LINK) {
		const hotelLink = EN_REWARD_LINK[hotel];

		return (
			<a className={className} href={hotelLink} target="_blank" rel="noopener noreferrer">
				REWARDS
			</a>
		);
	}

	if (hotel === 'osakaShinsaibashi') {
		let hotelLink = '';
		let wording = '';
		switch (lan) {
			case 'zh-TW':
				hotelLink = 'https://member.silkshotelgroup.com/Campaign/Index/JSOKS';
				wording = '愛旅行回饋計畫';
				break;
			case 'zh-CN':
				hotelLink = 'https://member.silkshotelgroup.com/zh-CN/Campaign/Index/JSOKS';
				wording = '爱旅行回馈计画';
				break;
			case 'en':
				hotelLink = 'https://member.silkshotelgroup.com/en/Campaign/Index/JSOKS';
				wording = 'REWARDS';
				break;
			case 'ja':
				hotelLink = 'https://member.silkshotelgroup.com/ja/Campaign/Index/JSOKS';
				wording = 'リワード';
				break;
			case 'ko':
				hotelLink = 'https://member.silkshotelgroup.com/en/Campaign/Index/JSOKS';
				wording = '보상';
				break;
			default:
				hotelLink = '';
				wording = '';
		}
		return (
			<a className={className} href={hotelLink} target="_blank" rel="noopener noreferrer">
				{wording}
			</a>
		);
	}

	return '';
};

export default NavExtraItem;



// WEBPACK FOOTER //
// ./src/components/molecules/NavExtraItem/index.js